<template>
    <rounded-container variant="dark">
        <template v-slot:title>System health</template>

        <b-container class="stats-container p-3">
            <b-row class="py-2">
                <b-col cols="6">Mercury</b-col>
                <b-col cols="6" class="text-right">
                    <b-badge :variant="health === null ? 'secondary' : health.online ? 'success' : 'danger'">
                        {{ health === null ? "checking" : health.online ? "online" : "offline" }}
                    </b-badge>
                </b-col>
            </b-row>

            <b-row v-for="row in feedRows" :key="row.name" class="py-2">
                <b-col cols="6">
                    {{ row.name }}
                    <span class="text-secondary d-block small">
                        {{ row.subscribed }} subscribed<span v-if="row.refused">,
                        {{ row.refused }} refused</span>
                    </span>
                </b-col>
                <b-col cols="3" class="text-right text-secondary small">
                    <span v-if="row.lastMessage">{{ row.lastMessage }}</span>
                </b-col>
                <b-col cols="3" class="text-right">
                    <b-badge :variant="row.variant">{{ row.state }}</b-badge>
                </b-col>
            </b-row>
        </b-container>
    </rounded-container>
</template>

<script>
import formatter from "@/mixins/formatter";
import RoundedContainer from "@/components/style/RoundedContainer.vue";

export default {
    name: "SystemHealth",
    mixins: [formatter],
    components: {
        RoundedContainer,
    },
    props: {
        health: {
            type: Object,
            default: null,
        },
    },
    computed: {
        /* A socket has four states worth telling apart. A feed nobody has asked for has
           never dialled, which is idle rather than broken. */
        feedRows() {
            if (!this.health || !this.health.feeds) return [];

            return this.health.feeds.map((feed) => {
                const state = !feed.connected
                    ? feed.connects
                        ? "disconnected"
                        : "idle"
                    : feed.silent
                        ? "quiet"
                        : "receiving";

                return {
                    ...feed,
                    state,
                    variant: {
                        receiving: "success",
                        quiet: "warning",
                        disconnected: "danger",
                        idle: "secondary",
                    }[state],
                    lastMessage:
                        feed.last_message_ms_ago === null
                            ? null
                            : `${Math.round(feed.last_message_ms_ago / 1000)}s ago`,
                };
            });
        },
    },
};
</script>
